// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Head & Upload ───────────────────────────── */
.hrcalendar-upload-card { margin-bottom: 12px; }
.hrcalendar-upload-row {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 8px;
}
.hrcalendar-file { max-width: 280px; margin-bottom: 0; }
.hrcalendar-demo-wrap {
  overflow-x: auto;
  border: 1px solid var(--n-200);
  border-radius: var(--radius-lg);
}
.hrcalendar-demo-table { min-width: 900px; margin-bottom: 0; }
.hrcalendar-demo-cell { font-size: 11px; }

/* ── Nav & Month ─────────────────────────────── */
.hrcalendar-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.hrcalendar-month {
  font-family:var(--font-display);
  font-size: 20px;
  font-weight: 700;
  color: var(--n-800);
}

/* ── Grid ────────────────────────────────────── */
.hrcalendar-grid {
  width: 100%;
  border-collapse: separate;
  border-spacing: 4px 4px;
}
.hrcalendar-weekday {
  font-size: 11px;
  font-weight: 700;
  color: var(--n-400);
  text-transform: uppercase;
  letter-spacing: 0.6px;
  text-align: center;
  padding: 4px 6px 8px;
}
.hrcalendar-weekday.is-weekend { color: var(--danger-400); }

/* ── Cell ────────────────────────────────────── */
.hrcalendar-cell-wrap { padding: 0 2px; vertical-align: top; }

.hrcalendar-cell {
  width: 100%;
  min-height: 64px;
  padding: 8px 6px 6px;
  border-radius: var(--radius-xl);
  border: 1.5px solid transparent;
  background: var(--n-50);
  text-align: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  transition: all var(--dur-base) ease;
}
.hrcalendar-cell:hover {
  background: var(--brand-50);
  border-color: var(--brand-200);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(59,130,246,0.10);
}
.hrcalendar-cell.is-weekend {
  background: var(--warning-50);
}
.hrcalendar-cell.is-weekend:hover {
  background: var(--warning-100);
  border-color: var(--warning-200);
}
.hrcalendar-cell.is-today {
  background: var(--brand-50);
  border-color: var(--clr-accent);
  box-shadow: 0 0 0 2px var(--brand-100);
}
.hrcalendar-cell.is-selected {
  background: var(--success-50);
  border-color: var(--success-400);
  box-shadow: 0 0 0 2px var(--success-100);
}

/* Date number */
.hrcalendar-cell-date {
  font-size: 14px;
  font-weight: 700;
  color: var(--n-800);
  line-height: var(--lh-tight);
}
.hrcalendar-cell.is-today .hrcalendar-cell-date {
  color: var(--clr-accent);
}
.hrcalendar-cell.is-weekend .hrcalendar-cell-date {
  color: var(--warning-600);
}

/* ── Dots ────────────────────────────────────── */
.hrcalendar-dots {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  justify-content: center;
  min-height: 8px;
}

.hrcalendar-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
}

/* Dot colors by event type */
.hrcalendar-dot--event     { background: var(--clr-accent); }
.hrcalendar-dot--holiday   { background: var(--danger-500); }
.hrcalendar-dot--milestone { background: var(--warning-400); }
.hrcalendar-dot--training  { background: var(--brand-400); }
.hrcalendar-dot--deadline  { background: var(--danger-400); }
.hrcalendar-dot--meeting   { background: var(--brand-400); }

.hrcalendar-dot-more {
  font-size: 10px;
  font-weight: 700;
  color: var(--n-500);
  line-height: var(--lh-tight);
  margin-top: 1px;
}

.hrcalendar-empty { min-height: 64px; }

/* ── Selected Date Detail Panel ──────────────── */
.hrcalendar-detail-panel {
  margin-top: 14px;
  border: 1.5px solid var(--n-200);
  border-radius: var(--radius-2xl);
  background: var(--n-0);
  overflow: hidden;
  animation: hrcal-slidein var(--dur-base) ease;
}

@keyframes hrcal-slidein {
  from { opacity: 0; transform: translateY(-6px); }
  to   { opacity: 1; transform: translateY(0); }
}

.hrcalendar-detail-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: linear-gradient(135deg, var(--n-50), var(--n-100));
  border-bottom: 1px solid var(--n-200);
}
.hrcalendar-detail-title {
  font-size: 13px;
  font-weight: 700;
  color: var(--n-900);
  font-family:var(--font-display);
}
.hrcalendar-detail-close {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  color: var(--n-400);
  padding: 2px 6px;
  border-radius: var(--radius-md);
  transition: all var(--dur-base);
}
.hrcalendar-detail-close:hover {
  background: var(--danger-100);
  color: var(--danger-500);
}

.hrcalendar-detail-empty {
  padding: 20px 16px;
  color: var(--n-400);
  font-size: 13px;
  text-align: center;
}

.hrcalendar-detail-list {
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.hrcalendar-detail-card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 10px 14px;
  border-radius: var(--radius-xl);
  border: 1px solid transparent;
}
.hrcalendar-detail-card--event {
  background: var(--brand-50);
  border-color: var(--brand-200);
}
.hrcalendar-detail-card--holiday {
  background: var(--danger-50);
  border-color: var(--danger-200);
}
.hrcalendar-detail-card--milestone {
  background: var(--warning-50);
  border-color: var(--warning-200);
}
.hrcalendar-detail-card--training {
  background: var(--brand-50);
  border-color: var(--brand-100);
}
.hrcalendar-detail-card--deadline {
  background: var(--danger-50);
  border-color: var(--danger-200);
}

.hrcalendar-detail-card-left {
  padding-top: 4px;
}
.hrcalendar-detail-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
}
.hrcalendar-detail-card-body { flex: 1 1; }
.hrcalendar-detail-card-title {
  font-size: 13px;
  font-weight: 700;
  color: var(--n-900);
  margin-bottom: 4px;
}
.hrcalendar-detail-card-meta {
  font-size: 11px;
  color: var(--n-500);
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}
.hrcalendar-detail-card-desc {
  margin-top: 6px;
  font-size: 12px;
  color: var(--n-700);
  line-height: var(--lh-normal);
}

/* ── Upcoming Events ─────────────────────────── */
.hrcalendar-upcoming {
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid var(--n-200);
}
.hrcalendar-upcoming-title {
  font-size: 14px;
  font-weight: 700;
  font-family:var(--font-display);
  margin-bottom: 8px;
  color: var(--n-800);
}
.hrcalendar-empty-upcoming {
  color: var(--n-400);
  font-size: 13px;
}
.hrcalendar-upcoming-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px solid var(--n-100);
}
.hrcalendar-upcoming-row:last-child { border-bottom: none; }
.hrcalendar-upcoming-date {
  font-size: 12px;
  color: var(--n-500);
  min-width: 90px;
  font-weight: 600;
}
.hrcalendar-upcoming-name {
  flex: 1 1;
  font-size: 13px;
  font-weight: 600;
  color: var(--n-900);
}

/* ── Create actions ──────────────────────────── */
.hrcalendar-create-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 16px;
}

/* ── Responsive ──────────────────────────────── */
@media (max-width: 1024px) {
  .hrcalendar-month { font-size: 18px; }
  .hrcalendar-cell  { min-height: 52px; padding: 6px 4px 4px; }
  .hrcalendar-cell-date { font-size: 12px; }
  .hrcalendar-dot { width: 6px; height: 6px; }
  .hrcalendar-upcoming-row { flex-wrap: wrap; }
  .hrcalendar-upcoming-date { min-width: unset; }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/HR/HrCalendarPg.css"],"names":[],"mappings":"AAAA,mDAAmD;AACnD,0BAA0B,mBAAmB,EAAE;AAC/C;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,kBAAkB;AACpB;AACA,mBAAmB,gBAAgB,EAAE,gBAAgB,EAAE;AACvD;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,+BAA+B;AACjC;AACA,yBAAyB,gBAAgB,EAAE,gBAAgB,EAAE;AAC7D,wBAAwB,eAAe,EAAE;;AAEzC,mDAAmD;AACnD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,mDAAmD;AACnD;EACE,WAAW;EACX,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;AACtB;AACA,iCAAiC,wBAAwB,EAAE;;AAE3D,mDAAmD;AACnD,wBAAwB,cAAc,EAAE,mBAAmB,EAAE;;AAE7D;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,+BAA+B;EAC/B,+BAA+B;EAC/B,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;AACtC;AACA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,2BAA2B;EAC3B,4CAA4C;AAC9C;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;AACA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,sCAAsC;AACxC;AACA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,6BAA6B;AAC7B,6BAA6B,6BAA6B,EAAE;AAC5D,6BAA6B,6BAA6B,EAAE;AAC5D,6BAA6B,8BAA8B,EAAE;AAC7D,6BAA6B,4BAA4B,EAAE;AAC3D,6BAA6B,6BAA6B,EAAE;AAC5D,6BAA6B,4BAA4B,EAAE;;AAE3D;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA,oBAAoB,gBAAgB,EAAE;;AAEtC,mDAAmD;AACnD;EACE,gBAAgB;EAChB,gCAAgC;EAChC,gCAAgC;EAChC,sBAAsB;EACtB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,8DAA8D;EAC9D,qCAAqC;AACvC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;AACjC;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;AACjC;AACA;EACE,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,6BAA6B;AAC/B;AACA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;AACA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;AACA,+BAA+B,SAAO,EAAE;AACxC;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,mDAAmD;AACnD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,qCAAqC;AACvC;AACA,sCAAsC,mBAAmB,EAAE;AAC3D;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,mDAAmD;AACnD;EACE,oBAAoB,eAAe,EAAE;EACrC,oBAAoB,gBAAgB,EAAE,oBAAoB,EAAE;EAC5D,wBAAwB,eAAe,EAAE;EACzC,kBAAkB,UAAU,EAAE,WAAW,EAAE;EAC3C,2BAA2B,eAAe,EAAE;EAC5C,4BAA4B,gBAAgB,EAAE;AAChD","sourcesContent":["/* ── Head & Upload ───────────────────────────── */\n.hrcalendar-upload-card { margin-bottom: 12px; }\n.hrcalendar-upload-row {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin-bottom: 8px;\n}\n.hrcalendar-file { max-width: 280px; margin-bottom: 0; }\n.hrcalendar-demo-wrap {\n  overflow-x: auto;\n  border: 1px solid var(--n-200);\n  border-radius: var(--radius-lg);\n}\n.hrcalendar-demo-table { min-width: 900px; margin-bottom: 0; }\n.hrcalendar-demo-cell { font-size: 11px; }\n\n/* ── Nav & Month ─────────────────────────────── */\n.hrcalendar-nav {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n.hrcalendar-month {\n  font-family:var(--font-display);\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--n-800);\n}\n\n/* ── Grid ────────────────────────────────────── */\n.hrcalendar-grid {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 4px 4px;\n}\n.hrcalendar-weekday {\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--n-400);\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  text-align: center;\n  padding: 4px 6px 8px;\n}\n.hrcalendar-weekday.is-weekend { color: var(--danger-400); }\n\n/* ── Cell ────────────────────────────────────── */\n.hrcalendar-cell-wrap { padding: 0 2px; vertical-align: top; }\n\n.hrcalendar-cell {\n  width: 100%;\n  min-height: 64px;\n  padding: 8px 6px 6px;\n  border-radius: var(--radius-xl);\n  border: 1.5px solid transparent;\n  background: var(--n-50);\n  text-align: center;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  transition: all var(--dur-base) ease;\n}\n.hrcalendar-cell:hover {\n  background: var(--brand-50);\n  border-color: var(--brand-200);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(59,130,246,0.10);\n}\n.hrcalendar-cell.is-weekend {\n  background: var(--warning-50);\n}\n.hrcalendar-cell.is-weekend:hover {\n  background: var(--warning-100);\n  border-color: var(--warning-200);\n}\n.hrcalendar-cell.is-today {\n  background: var(--brand-50);\n  border-color: var(--clr-accent);\n  box-shadow: 0 0 0 2px var(--brand-100);\n}\n.hrcalendar-cell.is-selected {\n  background: var(--success-50);\n  border-color: var(--success-400);\n  box-shadow: 0 0 0 2px var(--success-100);\n}\n\n/* Date number */\n.hrcalendar-cell-date {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--n-800);\n  line-height: var(--lh-tight);\n}\n.hrcalendar-cell.is-today .hrcalendar-cell-date {\n  color: var(--clr-accent);\n}\n.hrcalendar-cell.is-weekend .hrcalendar-cell-date {\n  color: var(--warning-600);\n}\n\n/* ── Dots ────────────────────────────────────── */\n.hrcalendar-dots {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  justify-content: center;\n  min-height: 8px;\n}\n\n.hrcalendar-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  display: inline-block;\n  flex-shrink: 0;\n}\n\n/* Dot colors by event type */\n.hrcalendar-dot--event     { background: var(--clr-accent); }\n.hrcalendar-dot--holiday   { background: var(--danger-500); }\n.hrcalendar-dot--milestone { background: var(--warning-400); }\n.hrcalendar-dot--training  { background: var(--brand-400); }\n.hrcalendar-dot--deadline  { background: var(--danger-400); }\n.hrcalendar-dot--meeting   { background: var(--brand-400); }\n\n.hrcalendar-dot-more {\n  font-size: 10px;\n  font-weight: 700;\n  color: var(--n-500);\n  line-height: var(--lh-tight);\n  margin-top: 1px;\n}\n\n.hrcalendar-empty { min-height: 64px; }\n\n/* ── Selected Date Detail Panel ──────────────── */\n.hrcalendar-detail-panel {\n  margin-top: 14px;\n  border: 1.5px solid var(--n-200);\n  border-radius: var(--radius-2xl);\n  background: var(--n-0);\n  overflow: hidden;\n  animation: hrcal-slidein var(--dur-base) ease;\n}\n\n@keyframes hrcal-slidein {\n  from { opacity: 0; transform: translateY(-6px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.hrcalendar-detail-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  background: linear-gradient(135deg, var(--n-50), var(--n-100));\n  border-bottom: 1px solid var(--n-200);\n}\n.hrcalendar-detail-title {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--n-900);\n  font-family:var(--font-display);\n}\n.hrcalendar-detail-close {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  color: var(--n-400);\n  padding: 2px 6px;\n  border-radius: var(--radius-md);\n  transition: all var(--dur-base);\n}\n.hrcalendar-detail-close:hover {\n  background: var(--danger-100);\n  color: var(--danger-500);\n}\n\n.hrcalendar-detail-empty {\n  padding: 20px 16px;\n  color: var(--n-400);\n  font-size: 13px;\n  text-align: center;\n}\n\n.hrcalendar-detail-list {\n  padding: 12px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.hrcalendar-detail-card {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 10px 14px;\n  border-radius: var(--radius-xl);\n  border: 1px solid transparent;\n}\n.hrcalendar-detail-card--event {\n  background: var(--brand-50);\n  border-color: var(--brand-200);\n}\n.hrcalendar-detail-card--holiday {\n  background: var(--danger-50);\n  border-color: var(--danger-200);\n}\n.hrcalendar-detail-card--milestone {\n  background: var(--warning-50);\n  border-color: var(--warning-200);\n}\n.hrcalendar-detail-card--training {\n  background: var(--brand-50);\n  border-color: var(--brand-100);\n}\n.hrcalendar-detail-card--deadline {\n  background: var(--danger-50);\n  border-color: var(--danger-200);\n}\n\n.hrcalendar-detail-card-left {\n  padding-top: 4px;\n}\n.hrcalendar-detail-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  display: inline-block;\n}\n.hrcalendar-detail-card-body { flex: 1; }\n.hrcalendar-detail-card-title {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--n-900);\n  margin-bottom: 4px;\n}\n.hrcalendar-detail-card-meta {\n  font-size: 11px;\n  color: var(--n-500);\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-wrap: wrap;\n}\n.hrcalendar-detail-card-desc {\n  margin-top: 6px;\n  font-size: 12px;\n  color: var(--n-700);\n  line-height: var(--lh-normal);\n}\n\n/* ── Upcoming Events ─────────────────────────── */\n.hrcalendar-upcoming {\n  margin-top: 14px;\n  padding-top: 12px;\n  border-top: 1px solid var(--n-200);\n}\n.hrcalendar-upcoming-title {\n  font-size: 14px;\n  font-weight: 700;\n  font-family:var(--font-display);\n  margin-bottom: 8px;\n  color: var(--n-800);\n}\n.hrcalendar-empty-upcoming {\n  color: var(--n-400);\n  font-size: 13px;\n}\n.hrcalendar-upcoming-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 0;\n  border-bottom: 1px solid var(--n-100);\n}\n.hrcalendar-upcoming-row:last-child { border-bottom: none; }\n.hrcalendar-upcoming-date {\n  font-size: 12px;\n  color: var(--n-500);\n  min-width: 90px;\n  font-weight: 600;\n}\n.hrcalendar-upcoming-name {\n  flex: 1;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--n-900);\n}\n\n/* ── Create actions ──────────────────────────── */\n.hrcalendar-create-actions {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  margin-top: 16px;\n}\n\n/* ── Responsive ──────────────────────────────── */\n@media (max-width: 1024px) {\n  .hrcalendar-month { font-size: 18px; }\n  .hrcalendar-cell  { min-height: 52px; padding: 6px 4px 4px; }\n  .hrcalendar-cell-date { font-size: 12px; }\n  .hrcalendar-dot { width: 6px; height: 6px; }\n  .hrcalendar-upcoming-row { flex-wrap: wrap; }\n  .hrcalendar-upcoming-date { min-width: unset; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
